import { render } from "./ArticleMast.vue?vue&type=template&id=5d9b55fb"
import script from "./ArticleMast.vue?vue&type=script&lang=js"
export * from "./ArticleMast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__